export const RUC_ROUTE_CONSTANTS = {
    BASE: 'ruc',
    TITLE: 'RUC Tracking',
} as const

export const RUC_API_ENDPOINTS = {
    TRACKING: '/api/aggregated/v1/users/{userId}/ruc-tracking',
} as const

export const RUC_API_DEFAULTS = {
    PAGE: 1,
    PER_PAGE: 10,
} as const

export const RUC_UI_TEXT = {
    RUC_TABLE_TITLE: 'RUC Tracking',
    SEARCH_PLACEHOLDER: 'Search by school name...',
    ALL_STATUS: 'All Status',
    ALL_CITIES: 'All Cities',
    ALL_PRODUCTS: 'All Products',
    STATUS_LABEL: 'Status',
    CITY_LABEL: 'City',
    PRODUCTS_LABEL: 'Products',
    COLUMN_SCHOOL_NAME: 'School Name',
    COLUMN_CITY: 'City',
    COLUMN_PRODUCT: 'Product',
    COLUMN_DELTA: 'Delta',
    COLUMN_STATUS: 'Status',
    COLUMN_LAST_FOLLOW_UP: 'Last Follow-up',
    RUC_SALES_FUNNEL_TITLE: 'RUC Funnel - Retention Pipeline',
    ERROR_MESSAGE: 'Failed to load RUC tracking data. Please try again later.',
    EMPTY_STATE: 'No schools match the selected filters.',
} as const

export const RUC_DISPLAY = {
    CURRENCY_SYMBOL: '₹',
    UNIT_LAKH_SUFFIX: 'L',
    ACHIEVED_LABEL: 'Achieved',
} as const

export const RUC_TARGET_MULTIPLIERS = {
    REVENUE_RETAINED: 1.15,
    SCHOOLS_RETAINED: 0.9,
} as const

export const RUC_METRIC_TITLES = {
    SCHOOLS_RETAINED: 'Schools Retained',
    REVENUE_TRACKING: 'Revenue Tracking',
} as const

export const RUC_TABLE_COLUMN_KEYS = {
    schoolName: 'schoolName',
    city: 'city',
    product: 'product',
    previousYearProducts: 'previousYearProducts',
    currentYearProducts: 'currentYearProducts',
    previousYearRevenue: 'previousRevenueDisplay',
    currentYearRevenue: 'currentRevenueDisplay',
    delta: 'deltaDisplay',
    status: 'status',
    lastFollowUp: 'lastFollowUp',
} as const

export const RUC_THRESHOLDS = {
    PROGRESS_DANGER_MAX: 30,
    PROGRESS_WARNING_MIN: 30,
    PROGRESS_WARNING_MAX: 80,
    PROGRESS_SUCCESS_MIN: 80,
} as const

export const RUC_FEATURE_FLAGS = {
    SHOW_TEAM_PERFORMANCE: false,
} as const

export const RUC_TEAM_UI_TEXT = {
    DASHBOARD_TITLE: 'Team Retention Upsell Cross-sell Dashboard',
    DASHBOARD_SUBTITLE:
        'Monitor team performance across retention, upselling, and cross-selling activities',
    TITLE: 'Team Retention Upsell Cross-sell Dashboard',
    SUBTITLE: 'Monitor team performance across retention, upselling, and cross-selling activities',
    REVENUE_RETAINED: 'Revenue Retained',
    GRAPH: 'Graph',
    TABLE: 'Table',
    SALES_REP: 'Sales Rep',
    SCHOOLS_TARGETED: 'Schools Targeted',
    SCHOOLS_RETAINED: 'Schools Retained',
    LAST_YEAR: 'Last Year',
    THIS_YEAR: 'This Year',
    RETENTION_PERCENT: 'Retention %',
    BASE_REVENUE: 'Base Revenue (Last Year)',
    REVENUE_RETAINED_THIS_YEAR: 'Revenue Retained (This Year)',
    TARGET_LABEL: 'Target (115% of Last Year)',
    RETAINED_LABEL: 'Revenue Retained',
    VARIANCE_LABEL: 'Variance',
    ACHIEVEMENT_LABEL: 'Achievement',
    SCHOOLS_LABEL: 'Schools',
    LAST_YEAR_REVENUE_LABEL: 'Last Year Revenue',
    TARGET_REVENUE_LABEL: 'Target Revenue',
    RETAINED_REVENUE_LABEL: 'Retained Revenue',
    TEAM_EMPTY_STATE: 'No team data available.',
} as const

export const RUC_METRIC_TARGETS = {
    REVENUE_TARGET_INR: 10000000,
} as const

export const RUC_TEAM_COLORS = {
    RED: '#ef4444',
    ORANGE: '#f39c12',
    YELLOW: '#fbbf24',
    GREEN: '#10b981',
    TARGET: '#9ca3af',
    CARD_BORDER: '#e5e7eb',
    ROW_STRIPE: '#f8fafc',
    BAR_TRACK: '#f3f4f6',
} as const

export const RUC_TEAM_THRESHOLDS = {
    RED_MAX: 33,
    ORANGE_MAX: 80,
    YELLOW_MAX: 100,
} as const

export const RUC_Y_AXIS_STEP_RATIOS = [1, 2, 5, 10]
export const DEFAULT_Y_AXIS_STEP_RATIOS = [0, 45]
export const MAX_Y_AXIS_TICKS = 8
export const MIN_Y_AXIS_TICKS = 4
export const Y_AXIS_TICKS_DIVISOR_FOR_MIN = 5
export const Y_AXIS_TICKS_DIVISOR_FOR_MAX = 6
export const LEAD_EXCLUDED_STAGES = new Set(['S0', 'S1', 'S2'])
